import { AfterViewInit, Component, ComponentFactoryResolver, EventEmitter, HostBinding, Input, OnChanges, OnInit, Output, ViewChild, ViewContainerRef } from "@angular/core";
import { IFilterOptions } from "@app/interfaces/filters/IFilterOptions";
import { IDashboardWidget } from "@app/main/modules/dashboard/_models/IDashboardWidget";
import { TranslationService } from "@app/services/translation.service";
import { ChartWidgetComponent } from "../chart-widget/chart-widget.component";
import { ClockWidgetComponent } from "../clock-widget/clock-widget.component";
import { GaugeWidgetComponent } from "../gauge-widget/gauge-widget.component";
import { MetricWidgetComponent } from "../metric-widget/metric-widget.component";
import { VTableWidgetComponent } from "../table-widget/table-widget.component";
import { VTachoWarningsWidgetComponent } from "../tacho-warnings-widget/tacho-warnings-widget.component";
import { VVehicleUtilisationWidgetComponent } from "../vehicle-utilisation-widget/vehicle-utilisation-widget.component";
import "./widget-container.component.scss";

export interface IWidgetInstance {
    hideTitleRow?: boolean;
}

@Component({
    selector: "widget-container",
    template: require("./widget-container.component.html")
})
export class WidgetContainerComponent implements OnInit, OnChanges, AfterViewInit {
    @ViewChild("widgetContents", { read: ViewContainerRef }) widgetContainer: ViewContainerRef;

    @Input() widget: IDashboardWidget;
    @Input() filterOptions: IFilterOptions;

    @Output() viewWidgetDataClick = new EventEmitter<IDashboardWidget>();

    @HostBinding("class.clickable") clickable = false;

    widgetInstance: IWidgetInstance;

    constructor(
        private readonly componentFactoryResolver: ComponentFactoryResolver, private readonly translationService: TranslationService) {
    }

    ngOnInit(): void {
    }

    ngOnChanges() {
        this.clickable = !!this.widget.DataWidgetParameters.DataSource.length;
    }

    ngAfterViewInit() {
        this.createWidgetComponents();
    }

    viewWidgetData($event) {
        $event.preventDefault();
        this.viewWidgetDataClick.emit(this.widget);
    }

    // ---

    // Move to service
    private createWidgetComponents(): void {
        // This may not be the most ideal solution but we need some kind of reference
        // to what component links to which widget type, so a map will do for now.
        var component = null
        const widgetMap = new Map();
        switch (this.widget.WidgetName) {

            case "clock-widget":
                component = ClockWidgetComponent;
                break;

            case "metric-widget":
                component = MetricWidgetComponent;
                break;

            case "chart-widget":
                component = ChartWidgetComponent;
                break;

            case "gauge-widget":
                component = GaugeWidgetComponent;
                break;

            case "table-widget":
                component = VTableWidgetComponent;
                break;

            case "vehicle-utilisation-widget":
                component = VVehicleUtilisationWidgetComponent;
                this.widget.HelpText = this.translationService.translate("Dashboard.HelpText.VehicleUtilisation")
                break;

            case "tacho-warnings-widget":
                component = VTachoWarningsWidgetComponent;
                break;
        }

        if (!component) {
            console.warn("No component type found for ", this.widget.WidgetName);
            (this.widgetContainer.element.nativeElement as HTMLElement).innerHTML = "NO WIDGET: " + this.widget.WidgetName;
            return;

            // Default to metric for now
            component = widgetMap.get(0);
        }

        this.loadComponent(component, this.widget);
    }

    private loadComponent(component: any, widget: IDashboardWidget): void {
        // Create the component
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
        const componentRef = this.widgetContainer.createComponent(componentFactory);

        this.widgetInstance = componentRef.instance;

        componentRef.instance['widget'] = widget;
        componentRef.instance['filterOptions'] = this.filterOptions;
        var htmlElement = componentRef.location.nativeElement as HTMLElement;
        htmlElement.classList.add("flex");

        // Force change detection
        componentRef.changeDetectorRef.detectChanges();
    }
}
